(() => {
  const params = new URLSearchParams(window.location.search);
  if (window.jn && window.jn.no_animations === 1 || params.has('clean')) {
    if( params.has('clean')) {
      document.addEventListener('DOMContentLoaded', () => {
        document.querySelectorAll('img.product-card__image--secondary').forEach(img => img.remove());
      });
    }
    return;
  }
  return;
  /* animation code removed */
})();

/* accordion */
document.querySelectorAll('.clamp').forEach(cl => {
  const c = cl.querySelector('.clamp__content');
  const b = cl.querySelector('.clamp__btn');
  if (!c || !b) return;
  // After styles apply, if full content fits in the preview, hide the button and remove the clamp.
  requestAnimationFrame(() => {
    if (c.scrollHeight <= c.clientHeight + 1) {
      b.style.display = 'none';
      c.style.maxHeight = 'none';
      c.style.webkitMaskImage = 'none';
      c.style.maskImage = 'none';
    }
  });
});
